// extracted by mini-css-extract-plugin
export default {"text":"AskQuestion_text__olXxP","textarea":"AskQuestion_textarea__+KGkp"};